export default [
  {
    path: '/apps/imagem-login/list',
    name: 'apps-imagem-login-list',
    component: () => import('@/views/cadastros/imagens-login/list/Index.vue'),
    meta: {
      pageTitle: 'Imagem Login',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/apps/imagem-login/edit/:id',
    name: 'apps-imagem-login-edit',
    component: () => import('@/views/cadastros/imagens-login/edit/EditImagemLogin.vue'),
    meta: {
      pageTitle: 'Editar Imagem Login',
      resource: 'AdminHanes',
    },
  },
];
